import { ReactElement } from "react";
import {
    ListTableColumn,
    createListTableColumns,
    renderEnumValue,
    renderOptionalTextWithTooltip,
    renderTextWithTooltip
} from "sprint-common-web";

import { FileRecordStatus } from "../../../../../../common/types/FileRecordStatus";
import { renderActionStatus } from "../../../../../../common/utils/renderActionStatus";
import { ProcessUpdateFileRecordStatusItem } from "../types/UpdateFileRecordStatusItem";

export const createUpdateFileRecordStatusColumns = (): ListTableColumn<ProcessUpdateFileRecordStatusItem>[] => {
    return createListTableColumns<ProcessUpdateFileRecordStatusItem>([
        {
            type: "basic",
            key: "deliveryFileName",
            name: "Delivery file name",
            minWidth: 200,
            maxWidth: 200,
            onRender: renderTextWithTooltip
        },
        {
            type: "basic",
            key: "filePath",
            name: "File path",
            minWidth: 100,
            maxWidth: 220,
            onRender: renderOptionalTextWithTooltip
        },
        {
            type: "basic",
            key: "content",
            name: "Content",
            minWidth: 510,
            maxWidth: 510
        },
        {
            type: "basic",
            key: "status",
            name: "Status",
            minWidth: 70,
            onRender: renderStatus
        },
        {
            type: "basic",
            key: "processStatus",
            name: "Process status",
            minWidth: 100,
            maxWidth: 100,
            isResizable: false,
            onRender: renderActionStatus
        }
    ]);
};

const renderStatus = <T>(item?: T, _index?: number, column?: ListTableColumn<T>): ReactElement | null => {
    return renderEnumValue(FileRecordStatus, item, _index, column);
};
